import FilterTagFilter from '../../common/components/List/FilterTagFilter/index.js'
import {hasMOManageTagPermissionSelector} from '../../data/me.js'
import {
  moTagOptionsSelector,
  moTagOptionTokensSelector,
} from '../../data/moTags.js'
import {
  createAndApplyTagToMOs,
  setTags,
  setUntagged,
  setTagFilterBy,
} from './moListActions.js'
import {
  selectedReferenceIDsSelector,
  moListQuerySelector,
} from './moListSelectors.js'
import {useSelector} from '../../store.js'

export default function MOTagFiltersDropdown() {
  const params = useSelector(moListQuerySelector)
  const referenceIDs = useSelector(selectedReferenceIDsSelector)
  const moTagOptions = useSelector(moTagOptionsSelector)
  const moTagOptionTokens = useSelector(moTagOptionTokensSelector)
  const hasMOManageTagPermission = useSelector(hasMOManageTagPermissionSelector)
  const moTagFilters = params.tags
  const untaggedSelected = params.untagged
  const filterOperator = params.tagFilterBy

  return (
    <FilterTagFilter
      dropdown="FILTER_MO_TAG_FILTER"
      selectedTags={moTagFilters}
      tagOptions={moTagOptions}
      tagOptionTokens={moTagOptionTokens}
      untaggedSelected={untaggedSelected}
      filterOperator={filterOperator}
      hasManageTagPermission={hasMOManageTagPermission}
      willApplyCreatedTag={referenceIDs.length !== 0}
      onCreate={() => createAndApplyTagToMOs(referenceIDs)}
      onSelect={(tag) => {
        const tags = moTagFilters.filter((name) => name !== tag.name)

        if (!moTagFilters.includes(tag.name)) {
          tags.push(tag.name)
        }

        setTags(tags)
      }}
      onToggleUntaggedFilter={(isSelected) => setUntagged(isSelected)}
      onTagFilterOperatorChange={(operator) => setTagFilterBy(operator)}
    />
  )
}
